function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./dist/ng2-cache-service'));


//////////////////
// WEBPACK FOOTER
// ./~/ng2-cache-service/index.js
// module id = 565
// module chunks = 3